import React from "react";
import PropTypes from "prop-types";
import copy from "clipboard-copy";

class CopyButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCopied: false
    };
  }

  handleClick = toClipboard => {
    copy(toClipboard);

    const { isCopied } = this.state;

    if (!isCopied) {
      this.setState({
        isCopied: true
      });
    }
  };

  render() {
    const { className, toClipboard, text } = this.props;
    const { isCopied } = this.state;

    return (
      <button
        className={`${className}${isCopied ? " is-copied" : ""}`}
        onClick={() => {
          this.handleClick(toClipboard);
        }}
      >
        {text}
      </button>
    );
  }
}

CopyButton.defaultProps = {
  className: "",
  text: "copy"
};

CopyButton.propTypes = {
  className: PropTypes.string,
  toClipboard: PropTypes.string.isRequired,
  text: PropTypes.string
};

export default CopyButton;
